import {
    makeActionCreator,
    TEST_ANSWER
} from '../actionTypes'

export const testAnswer = makeActionCreator(TEST_ANSWER,'userId','testType','testIndex','question','answer','trait')



// WEBPACK FOOTER //
// ./src/test/action.js